"use client";

import {
	Carousel,
	CarouselContent,
	CarouselItem,
	CarouselNext,
	CarouselPrevious,
} from "@/components/new/carousel";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Image from "next/image";

const VideoSlide = ({ video }: { video: string }) => {
	return (
		<CarouselItem>
			<div className="relative h-full w-full overflow-hidden rounded-md">
				<iframe
					src={video}
					title="YouTube video player"
					frameBorder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
					className="h-full w-full object-cover"
					allowFullScreen
				/>
			</div>
		</CarouselItem>
	);
};

type Props = {
	showClaimProductBanner?: boolean;
	video?: string;
	images?: string[];
	productSlug: string;
};

export const ProductCarousel = ({
	showClaimProductBanner = false,
	video,
	images = [],
	productSlug,
}: Props) => {
	const isAskTheAgentPro = productSlug === "ask-the-agent";

	return (
		<div>
			<Carousel
				opts={{
					loop: true,
					align: "start",
				}}
				className="w-full"
			>
				<CarouselContent className="py-4">
					{showClaimProductBanner && (
						<CarouselItem className="h-44 sm:basis-[90%] md:basis-[80%] lg:h-[450px]">
							<div className="relative h-full w-full overflow-hidden rounded-lg border border-gray-50 bg-gray-100 shadow">
								<Image
									fill
									alt="Claim this product"
									src="/images/unclaimed-product-thumbnail.png"
									className="h-full w-full object-cover object-center"
								/>
							</div>
						</CarouselItem>
					)}

					{video && <VideoSlide video={video} />}

					{images &&
						images.map((image) => (
							<CarouselItem key={image} className="h-44 sm:basis-[90%] md:basis-[80%] lg:h-[450px]">
								<div className="relative h-full w-full overflow-hidden rounded-lg border border-gray-50 bg-gray-100 shadow">
									<Image
										fill
										alt="Image"
										src={image || "/placeholder.svg"}
										className="h-full w-full object-contain"
									/>
								</div>
							</CarouselItem>
						))}
				</CarouselContent>
				<CarouselPrevious className="bg-gray-100 p-1 text-gray-500 data-[inactive]:opacity-50">
					<ChevronLeft className="h-5 w-5" />
				</CarouselPrevious>
				<CarouselNext className="bg-gray-100 p-1 text-gray-500 data-[inactive]:opacity-50">
					<ChevronRight className="h-5 w-5" />
				</CarouselNext>
			</Carousel>

			{isAskTheAgentPro ? (
				<div className="h-screen w-full rounded-md py-4">
					<iframe
						src="https://meettheagent.io/CamilleAnderson"
						title="YouTube video player"
						frameBorder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
						className="h-full w-full rounded-md object-cover"
						allowFullScreen
					/>
				</div>
			) : null}
		</div>
	);
};
